import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Logo from '../../proxymaster.webp';
import styles from './Header.module.scss';

const burgerIcon = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/list.svg';
const closeIcon = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/x-lg.svg';
const userIcon = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/person-fill.svg';

interface HeaderProps {
  onOpenPopup: () => void;
}

const Header: React.FC<HeaderProps> = ({ onOpenPopup }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [menuOpen, setMenuOpen] = useState(false);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        {/* Логотип (слева) */}
        <Link to="/" className={styles.logo}>
          <img src={Logo} alt="Logo" />
        </Link>

        {/* Кнопка бургера (видна на мобильных) */}
        <button
          className={`${styles.burgerBtn} ${menuOpen ? styles.open : ''}`}
          onClick={toggleMenu}
        >
          <img
            src={menuOpen ? closeIcon : burgerIcon}
            alt="menu icon"
            loading="lazy"
            className={`${menuOpen ? '' : ''}`}
          />
        </button>

        {/* Навигация — ссылки по центру */}
        <nav className={`${styles.nav} ${menuOpen ? styles.menuOpen : ''}`}>
          <ul>
            <li>
              <a href="/#who-needs-it" onClick={handleNavLinkClick}>
                {t('header.nav.features')}
              </a>
            </li>
            <li>
              <a href="/#prices" onClick={handleNavLinkClick}>
                {t('header.nav.prices')}
              </a>
            </li>
            <li>
              <a href="/#support" onClick={handleNavLinkClick}>
                {t('header.nav.support')}
              </a>
            </li>
            <li>
              <a href="/#reviews" onClick={handleNavLinkClick}>
                {t('header.nav.reviews')}
              </a>
            </li>
            <li>
              <a href="/#faq" onClick={handleNavLinkClick}>
                {t('header.nav.faq')}
              </a>
            </li>
            <li>
              <Link to="/partners" onClick={handleNavLinkClick}>
                {t('partners.navLink')}
              </Link>
            </li>
          </ul>

            <div className={styles.languageSwitcher}>
              <button
                className={`${styles.langBtn} ${currentLanguage === 'ru' ? styles.active : ''}`}
                onClick={() => changeLanguage('ru')}
              >
                Ru
              </button>
              <button
                className={`${styles.langBtn} ${currentLanguage === 'en' ? styles.active : ''}`}
                onClick={() => changeLanguage('en')}
              >
                En
              </button>
            </div>
          {/* Правая часть: переключатель языка и кнопка */}
          <div className={styles.rightSide}>
            <button className={styles.cabinetBtn} onClick={onOpenPopup}>
              <span className={styles.cabinetIcon}>
                <img src={userIcon} alt="user" loading="lazy" />
              </span>
              {t('header.cabinetBtn')}
            </button>
          </div>
        </nav>

        {/* Оверлей для мобильного меню */}
        {menuOpen && <div className={styles.overlay} onClick={toggleMenu}></div>}
      </div>
    </header>
  );
};

export default Header;
